































































































import { Component, Watch } from 'vue-property-decorator';

import {
  IWidgetSettings,
  IWidgetSettingsFormData
} from '@/models/Widget/settings';
import { WidgetThemesDictionary } from '@/models/Widget/themes';

import { updateRegistration } from '@/utils/updateRegistration';

import MerchantService from '@/api/MerchantService';
import ScreenshotService from '@/api/ScreenshotService';

import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';
import DevicePreviewBox from '@/componentsV2/organisms/DevicePreviewBox/DevicePreviewBox.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import WidgetConfigForm, {
  DEFAULT_TAB
} from '@/componentsV2/organisms/WidgetConfigForm/WidgetConfigForm.vue';
import {
  configWidgetFormDataFactory,
  transformWidgetPayload,
  transformWidgetSettingsToWidgetFormData
} from '@/views/Onboarding/helpers';
import { validation } from '@/views/Onboarding/Steps/LoyaltyWidget/validation';
import isMobile from '@/utils/mobile-check';
import getDifferenceObjects from '@/utils/getDifferenceObjects';

import WidgetEmptyState from './WidgetEmptyState.vue';
import eventBus from '@/utils/eventBus';
import ModalOptions from '@/components/Modal/ModalOptions';

import { needLaunchRewardsProgram } from '@/utils/start-guide';
import BillingModel from '@/views/Models/BillingModel.vue';
import { EBusinessStatus } from '@/models/business';

@Component({
  components: {
    ContentContainer,
    Typography,
    WidgetEmptyState,
    WidgetConfigForm,
    DevicePreviewBox,
    FilledButton
  }
})
export default class WidgetSettings extends BillingModel {
  merchantService = new MerchantService();
  screenshotService = new ScreenshotService();

  loading = false;
  loadingRestore = false;
  deviceActiveTab = DEFAULT_TAB;
  formData: IWidgetSettingsFormData = configWidgetFormDataFactory();
  formDataOld: IWidgetSettingsFormData = configWidgetFormDataFactory();
  gradientBg = '';
  showDescription = true;
  disabledScrollTemporaly = false;

  errors: any = [];

  get isMobileDevice() {
    return isMobile();
  }

  get tPrefix() {
    return 'common.components.widgetSettings';
  }

  get tPrefixForm() {
    return 'common.components.widgetConfigFormV2.labels';
  }

  get isValidForm() {
    return validation(this.formData, false);
  }

  get sectionsChanged() {
    const sections = [];
    const oldData = {
      ...this.formDataOld,
      previewState: '',
      imagePreview: '',
      enabled: true
    };
    const newData = {
      ...this.formData,
      previewState: '',
      imagePreview: '',
      enabled: true
    };
    const formDataDiferrenceStr = JSON.stringify(
      getDifferenceObjects(oldData, newData)
    );
    if (formDataDiferrenceStr.includes('widgetStyle'))
      sections.push('Widget Style');
    if (formDataDiferrenceStr.includes('welcome')) sections.push('Welcome');
    if (formDataDiferrenceStr.includes('placement')) sections.push('Placement');
    return sections;
  }

  get isValidChanged() {
    const sections = this.sectionsChanged;

    if (sections !== this.$store.getters['business/getWidgetWarnChanges'])
      this.$store.dispatch('business/SET_WIDGET_WARN_CHANGES', sections);
    return sections.length > 0;
  }

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get isDisabled() {
    return !this.currentProvider || needLaunchRewardsProgram();
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get pageTitle() {
    if (this.isMobileDevice || !this.isDisabled) return '';

    return 'Widget';
  }

  async created() {
    this.setGradientBg();

    if (this.currentProvider && this.currentProvider.settings) {
      this.formData = transformWidgetSettingsToWidgetFormData(this
        .currentProvider.settings as IWidgetSettings);
      this.getWidgetImagePreview();
      this.formDataOld = transformWidgetSettingsToWidgetFormData(this
        .currentProvider.settings as IWidgetSettings);
    }
  }

  @Watch('formData.color')
  setGradientBg() {
    this.gradientBg =
      WidgetThemesDictionary[this.formData.widgetStyle.color].primaryGradient;
  }

  async getWidgetImagePreview() {
    if (!this.business || !this.currentProvider) return;

    this.screenshotService.disableInterception();
    const res = await this.screenshotService.getWebsiteImage(this.business.id);
    this.screenshotService.initInterception();

    if (res.status !== 200) return;

    this.formData = {
      ...this.formData,
      imagePreview: res.data
    };
  }

  updateWidgetProviderSettings(widgetSettings: IWidgetSettings) {
    return this.merchantService.setConnectSettings(
      this.currentProvider.oauthId,
      widgetSettings
    );
  }

  onScroll(event: any) {
    if (window.innerHeight >= 870) return;
    const limit = event.target.scrollTop <= 80;
    if (
      !this.isMobileDevice &&
      limit !== this.showDescription &&
      !this.disabledScrollTemporaly
    ) {
      this.disabledScrollTemporaly = true;
      this.showDescription = limit;
      setTimeout(() => {
        this.disabledScrollTemporaly = false;
      }, 50);
    }
  }

  validData(data: IWidgetSettings) {
    if (!data.welcomeTitle && !data.welcomeDescription) {
      this.errors.push({
        value: 'title',
        label: this.$t(`${this.tPrefixForm}.titleError`)
      });
      this.errors.push({
        value: 'description',
        label: this.$t(`${this.tPrefixForm}.descriptionError`)
      });
      return false;
    }
    return true;
  }

  restoreModal() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'restoreWidget',
        false,
        true,
        true,
        true
      ),
      { restoreClick: this.restore }
    );
  }

  async restore() {
    const defaultConfig = configWidgetFormDataFactory();
    const payload = transformWidgetPayload(defaultConfig);
    this.errors = [];
    this.loadingRestore = true;

    const response = await this.updateWidgetProviderSettings(payload);

    if (response.status === 200) {
      this.$store.dispatch('merchant/UPDATE_WIDGET_PROVIDER_SETTINGS', payload);
      await updateRegistration('widget-setup');
      this.$notification('Restore successfully');
      this.formData = {
        ...transformWidgetSettingsToWidgetFormData(payload),
        imagePreview: this.formData.imagePreview
      };
      this.formDataOld = transformWidgetSettingsToWidgetFormData(payload);
      eventBus.$emit('widgetConfigFormSetFormData', { ...this.formData });
    }

    this.loadingRestore = false;
  }

  async submit() {
    const payload = transformWidgetPayload({ ...this.formData });
    this.errors = [];
    if (!this.validData(payload)) return;

    this.loading = true;

    const response = await this.updateWidgetProviderSettings(payload);

    if (response.status === 200) {
      this.$store.dispatch('merchant/UPDATE_WIDGET_PROVIDER_SETTINGS', payload);
      await updateRegistration('widget-setup');
      this.$notification('Changes saved successfully');
      this.formDataOld = transformWidgetSettingsToWidgetFormData(this
        .currentProvider.settings as IWidgetSettings);

      const params = this.$route.params;

      if (params.taskSlug) {
        this.$router.push('/home');

        return;
      }
    }

    this.loading = false;
  }

  async handleCanActivate() {
    if (this.business.coinPurchaseRatio === '0.00') {
      if (!this.formData.enabled) return;
      this.formData.enabled = false;

      eventBus.$emit('widgetConfigFormSetFormData', {
        ...this.formData
      });
      this.$notification(
        'Widget can only be activated after setting the reward rate.',
        'error',
        undefined,
        {
          onMessageClick: () => {
            this.$router.push('/coin/loyalty');
          }
        }
      );
      return;
    }

    if (
      this.business.status === EBusinessStatus.hidden.toLocaleLowerCase() &&
      this.formData.enabled
    ) {
      this.formData.enabled = false;

      eventBus.$emit('widgetConfigFormSetFormData', {
        ...this.formData
      });
      this.$notification(
        'Your business has been set as hidden by the Twism team. Please contact <span style="font-weight: 700">Twism support</span> to learn more.',
        'info',
        5000,
        {
          onMessageClick: () => {
            window.open('mailto:support@twism.com');
          }
        }
      );
      return;
    }

    const payload = transformWidgetPayload(this.formData);

    await this.updateWidgetProviderSettings(payload);
    this.$store.dispatch('merchant/UPDATE_WIDGET_PROVIDER_SETTINGS', payload);
  }

  handleChangeDevice(device: string) {
    this.deviceActiveTab = device;
  }

  handleChangeWidgetConfig(formData: IWidgetSettingsFormData) {
    this.formData = formData;
  }
}
